import { render, staticRenderFns } from "./ContainerFounderDocuments.vue?vue&type=template&id=9f93d722"
import script from "./ContainerFounderDocuments.vue?vue&type=script&lang=js"
export * from "./ContainerFounderDocuments.vue?vue&type=script&lang=js"
import style0 from "./ContainerFounderDocuments.vue?vue&type=style&index=0&id=9f93d722&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports